export function safeUUID() {
  if (typeof crypto !== "undefined") {
    if (typeof crypto.randomUUID === "function") {
      return crypto.randomUUID();
    }

    if (typeof crypto.getRandomValues === "function") {
      const bytes = new Uint8Array(16);
      crypto.getRandomValues(bytes);

      const b6 = bytes[6];
      const b8 = bytes[8];

      if (b6 !== undefined && b8 !== undefined) {
        bytes[6] = (b6 & 0x0f) | 0x40;
        bytes[8] = (b8 & 0x3f) | 0x80;
      }

      const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, "0"));

      return [
        hex.slice(0, 4).join(""),
        hex.slice(4, 6).join(""),
        hex.slice(6, 8).join(""),
        hex.slice(8, 10).join(""),
        hex.slice(10, 16).join(""),
      ].join("-");
    }
  }

  return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
}
